import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, ComboBox, Text } from '@reveni-io/reveni-ui'

import { availableLanguagesForUser } from '@/common/constants'
import AppContext from '@/common/context/app.context'

import { pagePlacementOptions } from '../DisplayMessageConfig/constants'
import ConsentTextField from './ConsentTextField/ConsentTextField'
import { consentModalTextFields } from './constants'
import { getMissingLanguages, hasPlacementError } from './helpers'
import * as Styles from './styles'

const DisplayConsentModalConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']
  const languages = availableLanguagesForUser.filter(lang => supportedLanguages.includes(lang))

  const placementError = hasPlacementError(errors)
  const placementOptions = pagePlacementOptions.map(option => ({ value: option.value, label: t(option.labelKey) }))

  const handleChangeText = (key, value, language) => {
    onChangeConfig({ [key]: { ...config[key], [language]: value } })
  }

  const handleChangePlacement = e => onChangeConfig({ display_message_placement: e.target.value })

  return (
    <Styles.Container>
      <Alert type="info">
        {t(
          'El customer no podrá continuar hasta que marque la casilla — asegúrate de que el mensaje y el texto del checkbox expliquen claramente qué están confirmando.'
        )}
      </Alert>
      {consentModalTextFields.map(field => (
        <ConsentTextField
          key={field.key}
          title={t(field.title)}
          description={t(field.description)}
          languages={languages}
          value={config[field.key]}
          onChange={(value, language) => handleChangeText(field.key, value, language)}
          missingLanguages={getMissingLanguages(errors, field.errorType)}
          disabled={disabled}
        />
      ))}
      <Styles.PlacementContainer>
        <Text type="bodyMBold">{t('Posición del mensaje')}</Text>
        <ComboBox
          label={t('Posición')}
          menuItems={placementOptions}
          handleChange={handleChangePlacement}
          value={config.display_message_placement || ''}
          fullWidth
          disabled={disabled}
          backgroundColor={theme.colors.background.primary}
          error={placementError}
          helperText={placementError ? t('Este campo es obligatorio') : ' '}
        />
      </Styles.PlacementContainer>
    </Styles.Container>
  )
}

export default DisplayConsentModalConfig
